import React from "react";
import { Row, Col, Card } from "antd";
import "./index.css";
import AddPlantCard from "./addplantCard";
import PlantInfoCard from "./plantInfoCard";
import { IoIosAddCircleOutline } from "react-icons/io";
const PlantInformation = ({locations,onChangePlantModal,deleteHandler,onHandleUpdate}) => {
  return (
    <Row justify="center" style={{ marginTop: "15px" }} gutter={[0, 10]}>
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <Card>
          <Row>
            <Col xs={18} sm={18} md={8} lg={6} xl={6}>
              <h2 className="text-left">Plant Information</h2>
            </Col>
            <Col xs={24} sm={24} md={24} lg={22} xl={22}>
              <Row justify="start" gutter={[20, 20]}>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <AddPlantCard
                    cardIcon={<IoIosAddCircleOutline size={35} />}
                    cardText={"Add New Plant"}
                    className="ant-card-body "
                    cardStyle={{ height: "258px" }}
                    onChangePlantModal={onChangePlantModal}
                  />
                </Col>
                {(locations||[]).map((item) => {
                  return (
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                      <PlantInfoCard deleteHandler={deleteHandler}  data={item} onHandleUpdate={onHandleUpdate}/>
                    </Col>
                  );
                })}
              </Row>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};
export default PlantInformation;
